import React from 'react';
import PerfilListPageContainer from './PerfilListPageContainer';

export class PerfilListPage extends React.Component{
    
    render(){
      return (
        <PerfilListPageContainer {...this.props}/>
      )
    }
}

